import React from 'react'
import gql from 'graphql-tag'
import { useMutation } from 'react-apollo'
import PropTypes from 'prop-types'
import { LocalizedText, IconAction, TooltipConfirm, PermissionTooltip, useRouter, useHandler } from 'labguard-cdk'
import { ConfigurationIcon, RemoveIcon } from 'src/components/common'
import { useAppPermission } from 'src/hooks'

const mutation = gql`
  mutation deleteGroup($id: ID!) {
    deleteGroup(id: $id) {
      id
    }
  }
`

const GroupActions = ({ group }) => {
  const enableDelete = useAppPermission('groups.delete')

  const {
    history: { push },
  } = useRouter()

  const [deleteGroup] = useMutation(mutation, {
    variables: { id: group.id },
    update: (cache, { data: { deleteGroup } }) => cache.deleteFragment(deleteGroup),
  })

  const onRemoveClick = useHandler(() => deleteGroup())
  const onConfigurationClick = useHandler(() => push(`/groups/${group.id}/configuration`))

  return (
    <div>
      <IconAction
        tooltip={<LocalizedText id="WEB_CONFIGURE_GROUP" />}
        icon={ConfigurationIcon}
        size="lg"
        onClick={onConfigurationClick}
      />
      <PermissionTooltip allowed={enableDelete}>
        <TooltipConfirm
          label={<LocalizedText id="WEB_CONFIRM_GROUP_DELETION" />}
          confirmLabel={<LocalizedText id="WEB_YES" />}
          cancelLabel={<LocalizedText id="WEB_NO" />}
          popperProps={{ placement: 'left' }}
          onConfirm={onRemoveClick}
          disabled={!enableDelete}
          hideOnCancel
          hideOnConfirm
        >
          <IconAction
            disabled={!enableDelete}
            tooltip={<LocalizedText id="WEB_DELETE_GROUP" />}
            icon={RemoveIcon}
            size="lg"
          />
        </TooltipConfirm>
      </PermissionTooltip>
    </div>
  )
}

GroupActions.propTypes = {
  group: PropTypes.object,
}

export default GroupActions
